<template>
  <!-- 盒子/饰品升级-盒子列表（升级） -->
  <div class="upgrade_boxList-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-switch v-model="switch_status" :active-value="1" :inactive-value="0" active-text="打开" inactive-text="关闭"
            @change="setSwitch">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="openBoxDialog(1)">添加盒子</el-button>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.origin_name" placeholder="请输入盒子名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.origin_id" placeholder="请输入盒子ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.status" placeholder="请选择盒子状态" @change="getData(1)">
            <el-option :value="undefined">全部</el-option>
            <el-option label="开启" :value="1"></el-option>
            <el-option label="关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getData(1)">确定</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
        <el-table-column prop="origin_id" label="盒子id" align="center">
        </el-table-column>
        <el-table-column prop="origin_name" label="盒子名称" align="center">
        </el-table-column>
        <el-table-column prop="origin_image" label="盒子图片" align="center">
          <template slot-scope="{ row }">
            <img style="width:100px" :src="row.origin_image" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="origin_price" label="盒子价格" align="center">
        </el-table-column>
        <el-table-column prop="upgrade_pro" label="升级概率" align="center">
        </el-table-column>
        <el-table-column prop="pro" label="盒子期望" align="center">
        </el-table-column>
        <el-table-column prop="status" label="盒子状态" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.status == 1">开启</span>
            <span v-if="row.status == 2">关闭</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="350px">
          <template slot-scope="{ row }">
            <el-row>
              <el-button type="primary" @click="openBoxDialog(2, row)">编辑
              </el-button>
              <el-button type="primary" @click="toDetails(row)">升级详情
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page" @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    </div>

    <!-- 弹窗 -->
    <EditBoxListDialog :visible="dialogVisible" v-model="dialogInfos" :typeDialog="dialogType"
      @close="dialogVisible = false" @refresh="getData(1)"></EditBoxListDialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import EditBoxListDialog from './component/EditBoxListDialog.vue'
export default {
  components: {
    EditBoxListDialog
  },
  data() {
    return {
      dialogVisible: false,//弹窗显示标志
      loading: false,//加载动画
      switch_status: 0,//打开或关闭 0是关闭 1是打开
      query: {
        page: 1,
        origin_name: undefined,
        origin_id: undefined,
        status: undefined
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传递弹窗数据
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData(1)
    this.getSwitch()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      getApiData('upgrade_list').then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openBoxDialog(num, rowInfo) {
      //打开添加/编辑弹窗
      this.dialogVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
      }
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    //去升级详情页面
    toDetails(rowInfo) {
      this.$router.push({ name: 'upgrade_details', params: { origin_id: rowInfo.origin_id } })
    },
    //获取升级开关状态
    getSwitch(val) {
      getApiData('upgrade_enable')
        .then(res => {
          if (res) {
            res.data ? this.switch_status = 1 : this.switch_status = 0
          }
        })
    },
    setSwitch() {
      //关闭/打开 升级开关
      let params = { "black": this.switch_status ? 1 : 0 }
      patchApiData('upgrade_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getSwitch()//刷新状态
        }).catch(err => {
          //关闭/打开 升级开关
          this.switch_status = this.switch_status ? 0 : 1
        })
    },
  }

}
</script>
<style lang="less" scoped>
.upgrade_boxList-box {
  header {}

  .body-box {
    // width: 800px;
  }
}
</style>